import { FleetEntry as FleetEntryModern } from "@shared/platform-api/generated"
import { FleetEntry as FleetEntryLegacy } from "@shared/types/index"
import { LocalDateBrand, Maybe } from "@flockcover/flock-svc-core-types"
import { Branded } from "io-ts"

import makeUUID from "../helpers/makeUUID"
import { localDateFromString } from "../formatters/dates"

// HACK - will be moved when we merge portals..
export const createUniqueRef = (
  registrationNumber: string,
  onCoverDate: string,
  offCoverDate?: Maybe<string>
): string => `VRN:${registrationNumber}-ON-COVER:${onCoverDate}-OFF-COVER:${offCoverDate ?? ``}`

export type LegacyFleetEntry = FleetEntryLegacy
export type ModernFleetEntry = FleetEntryModern

export function convertEntryToLegacy(connectedVrns: ReadonlyArray<string>) {
  return function (entry: ModernFleetEntry): LegacyFleetEntry {
    return {
      ...entry,
      sentToMID: (entry?.sentToMID as Branded<string, LocalDateBrand> | null) ?? null,
      isConnected: connectedVrns.includes(entry.vrn),
      vehicleId: makeUUID(entry.vehicle.id),
      abiGroup: entry.vehicle.abiGroup ?? null,
      fuelType: entry.vehicle.fuelType ?? ``,
      make: entry.vehicle.make ?? ``,
      model: entry.vehicle.model ?? ``,
      nominalStartYear: entry.vehicle.nominalStartYear ?? null,
      registrationNumber: entry.vrn,
      status: entry?.coverStatus,
      trim: entry.vehicle.trimLevel ?? null,
      type: entry.vehicle.type ?? ``,
      uniqueRef: createUniqueRef(
        entry.vrn,
        localDateFromString(entry.onCoverDate),
        entry.offCoverDate ? localDateFromString(entry.offCoverDate) : undefined
      ),
      onCoverDate: localDateFromString(entry.onCoverDate),
      offCoverDate: entry.offCoverDate ? localDateFromString(entry.offCoverDate) : null,
      createdAt: localDateFromString(entry.createdAt),
      abiCode: entry.vehicle.abiCode ?? null,
      grossWeight: entry.vehicle.grossWeight ?? null,
      numberOfSeats: entry.vehicle.numberOfSeats ?? null,
    }
  }
}
